<template>
  <div class="menu">
    <loading :active.sync="isLoading"></loading>
    <modal
      name="tableModal"
      :adaptive="true"
      :width="500"
      :height="350"
      class="vld-parent"
    >
      <loading
        :active.sync="isLoading"
        :isFullPage="false"
      ></loading>
      <h3 class="text-center my-6">{{ tableItem.mode === 'add' ? $t('Add New') : $t('Edit') }} {{ $t('Table') }}</h3>
      <form
        class="px-8"
        autocomplete="off"
      >
        <div>
          <div class="mb-4">
            <validation-provider
              name="Name"
              rules="required"
              v-slot="{ errors }"
            >
              <label
                class="block text-gray-700 text-sm font-bold mb-2"
                for="name"
              >
                {{ $t('Name') }}
              </label>
              <input
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                :placeholder="$t('Name')"
                v-model="tableItem.name"
              />
              <span class="text-red-700">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="mb-6">
            <validation-provider
              name="Capacity"
              rules="required|numeric"
              v-slot="{ errors }"
            >
              <label
                class="block text-gray-700 text-sm font-bold mb-2"
                for="capacity"
              >
                {{ $t('Capacity') }}
              </label>
              <input
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="capacity"
                type="text"
                :placeholder="$t('Capacity')"
                v-model="tableItem.capacity"
              />
              <span class="text-red-700">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="flex justify-center">
          <button
            class="flex items-center mr-2 rounded-full bg-green-400 text-center px-6 py-2 font-light text-white"
            type="button"
            @click="handleCreate"
          >
            {{ tableItem.mode === 'add' ? $t('Add New') : $t('Edit') }}
          </button>
          <button
            class="flex items-center ml-2 rounded-full bg-blue-400 text-center px-6 py-2 font-light text-white"
            type="button"
            @click="handleClose"
          >
            {{ $t('Close') }}
          </button>
        </div>
      </form>
    </modal>

    <modal
      name="deleteConfirmModal"
      :adaptive="true"
      :width="300"
      :height="200"
    >
      <h3 class="text-center my-6 mx-6">{{ $t('Are you sure you want to delete this table?') }}</h3>
      <div class="flex justify-center mt-4">
        <button
          class="flex items-center rounded-full bg-blue-400 text-center px-6 py-2 font-light text-white mr-2"
          type="button"
          @click="cancelConfirmDelete"
        >
          {{ $t('No') }}
        </button>
        <button
          class="flex items-center rounded-full bg-red-700 text-center px-6 py-2 font-light text-white ml-2"
          type="button"
          @click="handleDelete"
        >
          {{ $t('Yes, delete!') }}
        </button>
      </div>
    </modal>

    <section class="admin-tables-container bg-white shadow-xl mt-10 mx-10 rounded-lg px-4 py-8">
      <div class="flex justify-between items-center">
        <h2 class="text-xl">{{ $t('Tables') }}</h2>
        <button
          class="flex items-center rounded-full bg-green-400 text-center px-6 py-2 font-light text-white"
          @click="handleAddNew"
        >
          {{ $t('Add New') }}
          <eva-icon
            class="ml-4"
            name="plus-outline"
            animation="pulse"
            width="20"
            height="20"
            fill="#fff"
          ></eva-icon>
        </button>
      </div>
      <div class="w-full mt-6">
        <table class="w-full table-fixed">
          <thead class="text-left">
            <tr>
              <th class="px-4 py-2 w-1/12">#</th>
              <th class="px-4 py-2 w-4/12">{{ $t('Name') }}</th>
              <th class="px-4 py-2 w-4/12">{{ $t('Capacity') }}</th>
              <th class="px-4 py-2 w-3/12 text-right">{{ $t('Actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="border-t border-b"
              v-for="(item, index) in tables"
              :key="index"
            >
              <td class="px-4 py-2">{{ index + 1 }}</td>
              <td class="px-4 py-2">{{ item.name }}</td>
              <td class="px-4 py-2">{{ item.capacity }}</td>
              <td class="py-2 text-right">
                <eva-icon
                  class="mr-2"
                  name="edit-2-outline"
                  animation="pulse"
                  :width="tableIconSize"
                  :height="tableIconSize"
                  fill="#4A5568"
                  @click="handleEdit(index)"
                />
                <eva-icon
                  class="ml-2"
                  name="trash-outline"
                  animation="pulse"
                  :width="tableIconSize"
                  :height="tableIconSize"
                  fill="#c53030"
                  @click="handleDeleteConfirm(index)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import { db, auth } from '@/firebase';

export default {
  name: 'Menu',
  data() {
    return {
      isLoading: false,
      tableIconSize: 30,
      tables: [],
      tableItem: {
        name: '',
        capacity: 0,
        mode: '',
      },
      delete: null,
    };
  },
  async created() {
    this.isLoading = true;
    const { uid } = auth.currentUser;
    const restaurant = await db
      .collection('restaurants')
      .doc(uid)
      .get();

    if (restaurant.exists) {
      const { tables } = restaurant.data();
      if (tables) {
        this.tables = tables;
      }
    }
    this.isLoading = false;
  },
  methods: {
    handleAddNew() {
      this.tableItem = {
        name: '',
        capacity: 0,
        mode: 'add',
        index: this.tables.length,
      };
      this.$modal.show('tableModal');
    },
    async handleEdit(index) {
      const { name, capacity } = this.tables[index];
      this.tableItem = {
        name,
        capacity,
        mode: 'edit',
        index,
      };
      this.$modal.show('tableModal');
    },
    async handleCreate() {
      this.isLoading = true;
      const { uid } = auth.currentUser;
      const { mode, name, capacity, index } = this.tableItem;
      const newTableItem = { name, capacity: +capacity };
      const newTables = this.tables.slice();

      if (mode === 'add') {
        newTables.push(newTableItem);
      }

      if (mode === 'edit') {
        newTables[index] = newTableItem;
      }

      try {
        await db
          .collection('restaurants')
          .doc(uid)
          .update({ tables: newTables });
        this.tables = newTables;

        this.isLoading = false;
        this.$modal.hide('tableModal');
      } catch (e) {
        console.log('e :', e);
      }
    },
    handleDeleteConfirm(index) {
      this.$modal.show('deleteConfirmModal');
      this.delete = index;
    },
    cancelConfirmDelete() {
      this.delete = null;
      this.$modal.hide('deleteConfirmModal');
    },
    async handleDelete() {
      const { uid } = auth.currentUser;
      const index = this.delete;
      const newTables = this.tables.slice();
      newTables.splice(index, 1);
      try {
        await db
          .collection('restaurants')
          .doc(uid)
          .update({ tables: newTables });
        this.tables = newTables;
        this.$modal.hide('deleteConfirmModal');
      } catch (e) {
        console.log('e :', e);
      }
    },
    handleClose() {
      this.$modal.hide('tableModal');
    },
  },
};
</script>
<style lang="scss">
.admin-tables-container {
  height: 80vh;
}
</style>
